export var breakpoints = {maxWithPadding:1560,max:1440,laptop:1200,mediumLaptop:1050,smallLaptop:992,tablet:768,phone:576,smallPhone:375};